import styled from "styled-components";

export const Column = styled.div<{ gap?: string }>`
  display: flex;
  gap: ${(props) => (props.gap ? props.gap : "0.75rem")};
  flex-direction: column;
`;

export const Row = styled.div`
  display: flex;
  gap: 0.75rem;
  align-items: center;
`;
